import React from "react";
import Flex from "../../../../components/structure/Flex";
import { PropertyRoom } from "../../../../definitions/property";

interface RoomSummaryProps {
  count: number;
  meta: PropertyRoom;
}

const RoomSummary: React.FC<RoomSummaryProps> = ({ count, meta }) => {
  return (
    <Flex items="center" className="mt-2">
      {/* <img
        src={meta.images[0].image}
        alt=""
        className="w-24 h-16 bg-theme-surface rounded-lg"
      /> */}
      <span className="text-lg text-theme-placeholder">
        {meta.name} x {count}
      </span>
    </Flex>
  );
};

export default RoomSummary;
